import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import SwalAlert from "../../services/swalService/SwalService";
import { decryptAESID } from "../../utils/Encryption";
import { useSaveFinalCertificateAndCostAllocationMutation, useLazyGetCertificateGroupingDetailsForTVOCByIdQuery, useLazyGetProductDetailsListByProductInformationIdQuery, useUpdateApplicationStatusOnPeerReviewerReturnMutation, useSaveCertificateAndCostAllocationListForTVOCMutation, useSendCertificateGroupingRequestForReviewMutation, useValidateCertificateNumberForAssignmentMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import ToastService from "../../services/toastService/ToastService";
import ModalGroupingTable from "./components/ModalGroupingTable";
import CostAllocation from "./components/CostAllocation";
import { useLazyGetPeerReviewEvaluationDetailsByIdQuery, useLazyGetTVOCorFormaldehydeEmissionListQuery, useSendApplicationToCertificationMutation, useReturnApplicationToCaseOfficerByPeerReviewerMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { useAddAuditLogForSGBPApplcation } from "../../utils/AuditLogQuery/addAuditLog";

const CertificateGroupingListTVOCReview = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const applicationID = decryptAESID(id, false);
    const firstRowOriginalRef = useRef(null);
    const manualTickRowsRef = useRef(new Set());
    const { success, error, confirm } = SwalAlert();
    const tickOptions = [
      { label: "1 Tick", value: 1 },
      { label: "2 Ticks", value: 2 },
      { label: "3 Ticks", value: 3 },
      { label: "4 Ticks", value: 4 },
    ];

    const [productList, setProductList] = useState([]);
    const [tvocAndFormaldehydeEmissionList, SetTvocAndFormaldehydeEmissionList] = useState([]);
    const [approverOptions, setApproverOptions] = useState([]);
    const [internalNotes, setInternalNotes] = useState("");
    const [approver, setApprover] = useState();
    const [peerReviewer, setPeerReviewer] = useState();
    const [costAllocationList, setCostAllocationList] = useState([]);
    const [isReview, setIsReview] = useState(false);
    const [isApprove, setIsApprove] = useState(false);
    const [formErrors, setFormErrors] = useState({ costAllocation: {}, peerReviewer: "", approver: "" });
    const [appNumberValues, setAppNumberValues] = useState({});
    const [peerReviewerComment, setPeerReviewerComment] = useState("")
    const [approverReviewerComment, setApproverReviewerComment] = useState("")

    const [getProductDetailsListByProductInformationId, { isLoading: productListLoading, isSuccess: productListSuccess, data: productListData }] = useLazyGetProductDetailsListByProductInformationIdQuery();
    const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading }] = useLazyGetDropDownsForProductsAndServicesQuery();
    const [validateCertificateNumberForAssignment, { isLoading: checkCernumLoading }] = useValidateCertificateNumberForAssignmentMutation();
    const [sendCertificateGroupingForReview, { isLoading: sendCertificateGroupingForReviewLoading, isSuccess: sendCertificateGroupingForReviewSuccess, data: sendCertificateGroupingForReviewData }] = useSendCertificateGroupingRequestForReviewMutation();
    const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
    const [sendFinalCertificateAndCostAllocation, { data: sendFinalCertificateAndCostAllocationData }] = useSaveFinalCertificateAndCostAllocationMutation();

    const [getTVOCorFormaldehydeEmissionList, { isLoading: getTVOCorFormaldehydeEmissionListLoading, isSuccess: getTVOCorFormaldehydeEmissionSuccess, data: getTVOCorFormaldehydeEmissionListData }] = useLazyGetTVOCorFormaldehydeEmissionListQuery();
    const [saveCertificateAndCostAllocationListForTVOC, { isLoading: saveCertificateTvocisLoadding, isSuccess: saveCertificateTvocisSuccess, data: saveCertificateTvocdata }] = useSaveCertificateAndCostAllocationListForTVOCMutation();
    const [getCertificateGroupingDetailsForTVOCById, { isLoading: certificateGroupingDetailsLoading, isSuccess: certificateGroupingDetailsSuccess, data: certificateGroupingDetailsData }] = useLazyGetCertificateGroupingDetailsForTVOCByIdQuery();
    const [sendToFinalApprover, { isLoading: sendToFinalApproverLoading, isSuccess: sendToFinalApproverSuccess, data: sendToFinalApproverData, },] = useSendApplicationToCertificationMutation();
    const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();
    const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
    const { addAuditLog } = useAddAuditLogForSGBPApplcation();



    const errorSelectStyles = {
      control: (base, state) => ({
        ...base,
        borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        "&:hover": {
          borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        },
      }),
    };

    const approverOptionsMemo = useMemo(() => productsAndServicesDropDownsData?.filter((item) => item.dropdownName === "Approver List")
      .map((item) => ({ value: item.id, label: item.name })) ?? []
      , [productsAndServicesDropDownsData]);

    const itemCodeOptionsMemo = useMemo(() => productsAndServicesDropDownsData
      ?.filter((item) => item.dropdownName === "Items Codes")
      .map((item) => ({ value: item.id, label: item.name })) ?? []
      , [productsAndServicesDropDownsData]
    );

    useEffect(() => {
      const container = document.querySelector(".center-container");
      if (container) {
        container.scrollTop = 0;
      }
    }, []);

    useEffect(() => {
      const editID = decryptAESID(id, false);
      if (editID > 0) {
        productsAndServicesDropdown();
        getTVOCorFormaldehydeEmissionList();
        getProductDetailsListByProductInformationId(editID);
        getCertificateGroupingDetailsForTVOCById(editID);
        getPeerReviewEvaluationDetailsById(editID)
      }
    }, [id]);

    useEffect(() => {
      if (!productsAndServicesDropDownsLoading && productsAndServicesDropDownsData) {
        setApproverOptions(approverOptionsMemo);
      }
    }, [productsAndServicesDropDownsLoading, productsAndServicesDropDownsData, approverOptionsMemo]);

    useEffect(() => {
      if (!productListLoading && productListSuccess && productListData) {
        setProductList(productListData);
        const list = Array.isArray(productListData) ? productListData : productListData?.data || [];
        firstRowOriginalRef.current = list.length > 0 ? list[0].applicationNumber : null;

        //  try
        const initialApp = {};
        productListData?.forEach((item) => { initialApp[item.sgbpProductId] = item.applicationNumber ?? ""; });
        setAppNumberValues(initialApp);

      }
    }, [productListLoading, productListSuccess, productListData,]);

    useEffect(() => {
      if (!getTVOCorFormaldehydeEmissionListLoading && getTVOCorFormaldehydeEmissionSuccess && getTVOCorFormaldehydeEmissionListData) {
        if (getTVOCorFormaldehydeEmissionListData?.length > 0) {
          SetTvocAndFormaldehydeEmissionList(getTVOCorFormaldehydeEmissionListData)
        }
      }
    }, [getTVOCorFormaldehydeEmissionListLoading, getTVOCorFormaldehydeEmissionSuccess, getTVOCorFormaldehydeEmissionListData]);

    useEffect(() => {
      if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
        if (!returnToCaseOfficerData.hasError) {
          addAuditLog({ SGBPSApplicationId: applicationID, AuditLogDescription: "SGBPS Application Returned to Case Officer By Peer Reviewer", TriggredTimeStatusId: certificateGroupingDetailsData?.statusId });
          ToastService.success("Application Returned to Case Officer");
        navigate("/viewApplicationTaskList");
        } else {
          ToastService.error(returnToCaseOfficerData.errorMessage);
        }
      }
    }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);


    useEffect(() => {
      if (productList && productList.length > 0) {
        const list = Array.isArray(productList) ? productList : productList?.data || [];

        setCostAllocationList((prevRows) =>
          buildCostAllocationRows(list, itemCodeOptionsMemo, prevRows)
        );
      }
    }, [productList, itemCodeOptionsMemo, tvocAndFormaldehydeEmissionList]);
    useEffect(() => {
      if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
        setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
        setApproverReviewerComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
      }
    }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);

    useEffect(() => {
      if (!certificateGroupingDetailsLoading && certificateGroupingDetailsSuccess && certificateGroupingDetailsData && productListData) {

        const list = certificateGroupingDetailsData?.getCertificateAndCostAllocationForTVOCList;


        if (list?.length > 0) {
          setIsApprove(certificateGroupingDetailsData?.statusId == 8);
          const rows = buildCostAllocationRows(productListData, itemCodeOptionsMemo);

          rows.forEach((row) => {
            let certificateNumber = row.label;
            let prefix = 0;
            const lastSlashIndex = row.label.lastIndexOf("/");
            if (lastSlashIndex !== -1) {
              certificateNumber = row.label.substring(0, lastSlashIndex);
              prefix = row.label.substring(lastSlashIndex + 1);
            }

            const existingAllocation = list.find((x) => {
              const [xCertificateNumber, xPrefix = 0] = x.certificateNumber.split("/");
              return (
                xCertificateNumber === certificateNumber &&
                Number(xPrefix) === Number(prefix || 0)
              );
            });

            row.value = existingAllocation
              ? itemCodeOptionsMemo?.find((i) => i.value === existingAllocation.itemCode) ?? null
              : null;

            row.tickValue = existingAllocation
              ? tickOptions?.find((t) => t.value === existingAllocation.tickRating) ?? null
              : null;

            row.declared = existingAllocation?.declaredGWPValue ?? null;
            row.sgbpCertificateGroupingId = existingAllocation ? existingAllocation.sgbpCertificateGroupingId : 0;
            row.finalCertificateAndCostAllocationId = existingAllocation ? existingAllocation.finalCertificateAndCostAllocationId : 0;
            row.tvocEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isTVOC === true && item.tickRating === row?.tickValue?.value)?.actualValue ?? "";
            row.formaldehydeEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isFormul === true && item.tickRating === row?.tickValue?.value)?.actualValue ?? "";

          });

          setCostAllocationList(rows);

          const peerReviewerOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.peerReviewerId);
          const approverOption = approverOptionsMemo?.find((item) => item.value === certificateGroupingDetailsData?.approverId);
          setPeerReviewer(peerReviewerOption || null);
          setApprover(approverOption || null);
          setInternalNotes(certificateGroupingDetailsData?.commentFromCaseOfficer || "");
        }
      }
    }, [certificateGroupingDetailsLoading, certificateGroupingDetailsSuccess, certificateGroupingDetailsData, productListData, itemCodeOptionsMemo, approverOptionsMemo]);


    useEffect(() => {
      if (!saveCertificateTvocisLoadding && saveCertificateTvocisSuccess && saveCertificateTvocdata) {
        if (saveCertificateTvocdata?.hasError) {
          ToastService.error(saveCertificateTvocdata?.errorMessage);
        }
        else if (!isReview) {
          success("Certificate Grouping Request Updated Successfully!");
        }
        setIsReview(false);
      }
    }, [saveCertificateTvocisLoadding, saveCertificateTvocisSuccess, saveCertificateTvocdata]);

    useEffect(() => {
      if (!sendCertificateGroupingForReviewLoading && sendCertificateGroupingForReviewSuccess && sendCertificateGroupingForReviewData) {
        if (!sendCertificateGroupingForReviewData.hasError) {
          handleSave();
          handleFinalCostAllocation();
          ToastService.success("Review Request sent successfully");
        navigate("/viewApplicationTaskList");
        } else {
          ToastService.error(sendCertificateGroupingForReviewData.errorMessage);
        }
      }
    }, [sendCertificateGroupingForReviewLoading, sendCertificateGroupingForReviewSuccess, sendCertificateGroupingForReviewData]);

    useEffect(() => {
      if (!sendToFinalApproverLoading && sendToFinalApproverSuccess && sendToFinalApproverData) {
        if (!sendToFinalApproverData.hasError) {
          addAuditLog({ SGBPSApplicationId: applicationID, AuditLogDescription: "SGBS Application Sent to Final Approver", TriggredTimeStatusId: certificateGroupingDetailsData?.statusId });
          ToastService.success("Application Sent to Final Approver Successfully");
          navigate("/viewApplicationTaskList")
        } else {
          ToastService.error(sendToFinalApproverData.errorMessage);
        }
      }
    }, [sendToFinalApproverLoading, sendToFinalApproverSuccess, sendToFinalApproverData]);

    const parseRating = (rating) => {
      const n = Number(rating);
      return rating !== undefined && rating !== null && rating !== "" && !Number.isNaN(n)
        ? n
        : null; 
    };

    const computeMinRatingMap = (list) => {
      const groupMap = new Map();
      const declaredValueMap = new Map();
      (list || []).forEach((item) => {
        const certNumber = item?.applicationNumber;
        const certPrefix = item?.certPrefix;
        if (!certNumber) return; 
        const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;

        const rating = parseRating(item?.rating);
        const additionalFieldValue = item?.additionalFieldValue;
        if (!groupMap.has(key)) {
          groupMap.set(key, rating);
          declaredValueMap.set(key, additionalFieldValue);
        } else if (rating !== null) {
          const currentMin = groupMap.get(key);
          groupMap.set(key, currentMin === null ? rating : Math.min(currentMin, rating));
          if (currentMin === null || rating < currentMin) {
            declaredValueMap.set(key, additionalFieldValue);
          }
        }
      });
      return { groupMap, declaredValueMap };
    };

    const buildCostAllocationRows = (list, itemCodes, existingRows = []) => {
      const uniqueMap = new Map();
      list.forEach((item) => {
        const certNumber = item.applicationNumber;
        const certPrefix = item.certPrefix;
        const key = certPrefix ? `${certNumber}/${certPrefix}` : certNumber;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, true);
        }
      });
      // const minRatingMap = computeMinRatingMap(list);
      const { groupMap: minRatingMap, declaredValueMap } = computeMinRatingMap(list);

      return Array.from(uniqueMap.keys()).map((label, index) => {
        // const existingExact = existingRows?.find((row) => row.label === label);
        // const existingByIndex = existingRows?.[index];
        const existingExact = existingRows?.find((row) => row.label === label);
        const existingByIndex = existingRows?.[index];
        const rowId = index + 1;

        const minRating = minRatingMap.get(label) ?? null;
        const defaultTick = tickOptions.find((t) => t.value === minRating) ?? null;

        const isManual = manualTickRowsRef.current.has(rowId);

        const tickValue = isManual && existingExact ? existingExact.tickValue : defaultTick;
        const declerdValue = declaredValueMap.get(label) ?? null;

        const tvocEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isTVOC === true && Number(item.tickRating) === Number(tickValue?.value))?.actualValue ?? "";
        const formaldehydeEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isFormul === true && Number(item.tickRating) === Number(tickValue?.value))?.actualValue ?? "";

        return {
          id: index + 1,
          label,
          options: itemCodes,
          value: existingExact ? existingExact.value : null,
          declared: declerdValue,
          tvocEmission,
          formaldehydeEmission,
          tickValue,
          sgbpCertificateGroupingId: existingExact?.sgbpCertificateGroupingId ?? existingByIndex?.sgbpCertificateGroupingId ?? 0,
          finalCertificateAndCostAllocationId: existingExact?.finalCertificateAndCostAllocationId ?? existingByIndex?.finalCertificateAndCostAllocationId ?? 0,
          tickOptions: tickOptions,
        };
      });
    };

    const handleCostAllocationChange = useCallback((rowId, selectedOption) => {
      setCostAllocationList((prevRows) =>
        prevRows.map((row) => (row.id === rowId ? { ...row, value: selectedOption ?? null } : row))
      );
      setFormErrors((prev) => {
        if (!prev.costAllocation[rowId]?.itemCode) return prev;
        const nextRow = { ...prev.costAllocation[rowId] };
        delete nextRow.itemCode;
        const nextCostAllocation = { ...prev.costAllocation };
        if (Object.keys(nextRow).length > 0) {
          nextCostAllocation[rowId] = nextRow;
        } else {
          delete nextCostAllocation[rowId];
        }
        return { ...prev, costAllocation: nextCostAllocation };
      });
    }, []);


    const handleTickRatingChange = useCallback((rowId, selectedOption) => {
      if (tvocAndFormaldehydeEmissionList?.length > 0) {
        var tovcVal = tvocAndFormaldehydeEmissionList.find((item) => item.isTVOC === true && Number(item.tickRating) === Number(selectedOption?.value))?.actualValue;
        var formVal = tvocAndFormaldehydeEmissionList.find((item) => item.isFormul === true && Number(item.tickRating) === Number(selectedOption?.value))?.actualValue;
      }
      manualTickRowsRef.current.add(rowId);
      setCostAllocationList((prevRows) =>
        prevRows.map((row) => (row.id === rowId ? { ...row, tickValue: selectedOption ?? null, tvocEmission: tovcVal ?? "", formaldehydeEmission: formVal ?? "" } : row))
      );
      setFormErrors((prev) => {
        if (!prev.costAllocation[rowId]?.tickRating) return prev;
        const nextRow = { ...prev.costAllocation[rowId] };
        delete nextRow.tickRating;
        const nextCostAllocation = { ...prev.costAllocation };
        if (Object.keys(nextRow).length > 0) {
          nextCostAllocation[rowId] = nextRow;
        } else {
          delete nextCostAllocation[rowId];
        }
        return { ...prev, costAllocation: nextCostAllocation };
      });
    }, [tvocAndFormaldehydeEmissionList]);

    const handleTVOCAndFormaldehydeChange = useCallback((rowId, fieldName, value) => {
      setCostAllocationList(prevRows =>
        prevRows.map(row =>
          row.id === rowId
            ? { ...row, [fieldName]: value }
            : row
        )
      );
      setFormErrors((prev) => {
        if (!prev.costAllocation[rowId]?.declared) return prev;
        const nextRow = { ...prev.costAllocation[rowId] };
        delete nextRow.declared;
        const nextCostAllocation = { ...prev.costAllocation };
        if (Object.keys(nextRow).length > 0) {
          nextCostAllocation[rowId] = nextRow;
        } else {
          delete nextCostAllocation[rowId];
        }
        return { ...prev, costAllocation: nextCostAllocation };
      });
    }, []);

    const parseApplicationNumber = (value) => {
      const str = String(value ?? "");
      const match = str.match(/^([A-Za-z]+)(\d+)$/);
      if (!match) return null;

      const [, prefix, digitsPart] = match;
      return {
        prefix,
        number: parseInt(digitsPart, 10),
        width: digitsPart.length,
      };
    };
    const validateApplicationNumber = (referenceValue, newValue, apiFlage, isExisted) => {
      const referenceParsed = parseApplicationNumber(referenceValue);
      const newParsed = parseApplicationNumber(newValue);

      if (!referenceParsed || !newParsed) {
        ToastService.error("Invalid application number format.");
        return false;
      }

      // Letters prefix must never change
      if (referenceParsed.prefix !== newParsed.prefix) {
        ToastService.error("Prefix cannot be changed.");
        return false;
      }

      const diff = newParsed.number - referenceParsed.number;
      // Width must stay the same, UNLESS the number just crossed into needing
      // one more digit (e.g. 99999 -> 100000), in which case width can grow by exactly 1.
      const expectedWidthForNewNumber = String(newParsed.number).length;
      const widthGrewNaturally =
        newParsed.width === Math.max(referenceParsed.width, expectedWidthForNewNumber) &&
        newParsed.width >= referenceParsed.width;

      if (!widthGrewNaturally) {
        ToastService.error("Invalid number format — digit padding is incorrect.");
        return false;
      }

      let isRecordExisted = productListData?.filter((item) => item.applicationNumber == newValue)

      // if (diff === 0 || diff === 1) return true; // same as reference, or +1
      if (diff === 0) return true; // same as reference, or +1

      if (diff === 1) {
        if (isExisted) {
          if (isRecordExisted.length > 0) {
            return true
          } else {
            return false
          }
        }
        return true
      }
      if (diff < 0) {
        ToastService.error("This number cannot be decreased.");
        return false;
      }
      if (diff > 0) {
        if (!apiFlage) {
          return true
        }
      }

      ToastService.error("Please increase by 1 at a time — the number cannot skip.");
      return false;
    };
    const handleAppNumberChange = useCallback((id, value) => {
      setAppNumberValues((prev) => ({ ...prev, [id]: value }));
    }, []);

    const handleApplicationNumberBlur = useCallback(async (id, value) => {
      try {
        const response = await validateCertificateNumberForAssignment({ CertificateNumber: value, }).unwrap();
        let { isCertificateNumberAssigned, nextCertificateSequenceNumber, isExisted } = response;
        const newParsed = parseApplicationNumber(nextCertificateSequenceNumber);
        const index = productList.findIndex((item) => item.sgbpProductId === id);
        const oldValue = productListData?.filter((item) => item.sgbpProductId === id);
        if (value == oldValue[0]?.applicationNumber) {
          return true;
        }
        if (index === -1) return false;

        const current = productList[index];
        const ownParsed = parseApplicationNumber(current.applicationNumber);
        if (!ownParsed) {
          ToastService.error("Invalid application number format.");
          return false;
        }
        const referenceValue = index === 0 ? (firstRowOriginalRef.current ?? current.applicationNumber) : productList[index - 1].applicationNumber;
        const isValid = validateApplicationNumber(referenceValue, value, isCertificateNumberAssigned, isExisted);
        if (!isValid) return false;
        // ---- API call on blur ----
        if (response?.hasError) {
          ToastService.error(response.errorMessage || "Certificate number already assigned or invalid.");
          return false;
        }
      } catch (err) {
        console.log(err);
        ToastService.error("Something went wrong while validating certificate number.");
        return false;
      }
      // ---------------------------

      setProductList((prev) =>
        prev.map((item) => (item.sgbpProductId === id ? { ...item, applicationNumber: value } : item))
      );
      return true;
    }, [productList, validateCertificateNumberForAssignment]);

    const handleProductChange = useCallback((id, field, value) => {
      let extra = {};
      if (field === "rating") {
        extra.tvocEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isTVOC === true && Number(item.tickRating) === Number(value))?.actualValue ?? "";
        extra.formaldehydeEmission = tvocAndFormaldehydeEmissionList.find((item) => item.isFormul === true && Number(item.tickRating) === Number(value))?.actualValue ?? "";
      }
      setProductList((prev) =>
        prev.map((item) => (item.sgbpProductId === id ? { ...item, [field]: value, ...extra } : item))
      );
    }, [tvocAndFormaldehydeEmissionList]);

    const validateForm = useCallback(() => {
      const errors = { costAllocation: {}, peerReviewer: "", approver: "" };
      let firstErrorMessage = "";
      costAllocationList.forEach((row) => {
        const rowError = {};
        if (!row.value) {
          rowError.itemCode = "Item Code is required.";
          if (!firstErrorMessage) firstErrorMessage = `Please select Item Code for "${row.label}".`;
        }
        if (!row.tickValue) {
          rowError.tickRating = "Tick Rating is required.";
          if (!firstErrorMessage) firstErrorMessage = `Please select Tick Rating for "${row.label}".`;
        }
        if (!row.tvocEmission || String(row.tvocEmission).trim() === "") {
          rowError.tvocEmission = "TVOC Emission is required.";
          if (!firstErrorMessage) firstErrorMessage = `Please enter TVOC Emission for "${row.label}".`;
        }
        if (!row.formaldehydeEmission || String(row.formaldehydeEmission).trim() === "") {
          rowError.formaldehydeEmission = "Formaldehyde Emission is required.";
          if (!firstErrorMessage) firstErrorMessage = `Please enter Formaldehyde Emission for "${row.label}".`;
        }
        if (Object.keys(rowError).length > 0) {
          errors.costAllocation[row.id] = rowError;
        }
      });
      if (!peerReviewer) {
        errors.peerReviewer = "Peer Reviewer is required.";
        if (!firstErrorMessage) firstErrorMessage = "Please select Peer Reviewer.";
      }

      if (!approver) {
        errors.approver = "Approver is required.";
        if (!firstErrorMessage) firstErrorMessage = "Please select Approver.";
      }

      setFormErrors(errors);

      if (firstErrorMessage) {
        error(firstErrorMessage);
        return false;
      }
      return true;
    }, [costAllocationList, peerReviewer, approver]);

    const handleSave = useCallback(() => {
      if (!validateForm()) return;
      const applicationId = decryptAESID(id?.toString(), false);

      const req = {
        Comments: internalNotes,
        PeerReviewerId: peerReviewer?.value,
        ApproverId: approver?.value,
        SGBPSApplicationId: applicationId,
        CertificateAndCostAllocationListForTVOCRequest: costAllocationList.map((row) => {
          const [certificateNumber, certPrefix] = row.label.split("/");
          return {
            SGBPSApplicationId: applicationId,
            ItemCode: row.value?.value,
            CertificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
            TickRating: row.tickValue?.value ?? null,
            TVOCEmission: row.tvocEmission ?? null,
            FormaldehydeEmission: row.formaldehydeEmission ?? null,
          };
        }),

        ModelGroupingListForTVOCRequest: productList.map(
          ({ rating, certPrefix, sgbpProductId, applicationNumber, declared, textValue, tvocEmission, formaldehydeEmission }) => ({
            SgbpProductId: sgbpProductId,
            Rating: rating !== undefined && rating !== null && rating !== "" ? Number(rating) : null,
            CertPrefix: certPrefix === undefined || certPrefix === null || certPrefix === "" || Number(certPrefix) === 0 ? null : Number(certPrefix),
            CertificateNumber: String(applicationNumber),
            DeclaredGWPValue: declared === undefined || declared === null || String(declared).trim() === "" ? null : String(declared).trim(),
            TextValue: textValue === undefined || textValue === null || String(textValue).trim() === "" ? null : String(textValue).trim(),
            TVOCEmission: tvocEmission === undefined || tvocEmission === null || String(tvocEmission).trim() === "" ? null : String(tvocEmission).trim(),
            FormaldehydeEmission: formaldehydeEmission === undefined || formaldehydeEmission === null || String(formaldehydeEmission).trim() === "" ? null : String(formaldehydeEmission).trim(),
          })
        ),
      };

      saveCertificateAndCostAllocationListForTVOC(req);
    }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList, saveCertificateAndCostAllocationListForTVOC]);

    const handleReviewRequest = useCallback(() => {
      if (!validateForm()) return;
      setIsReview(true);
      const req = { sGBPProductInformationId: decryptAESID(id) };
      sendCertificateGroupingForReview(req);
    }, [validateForm, id, sendCertificateGroupingForReview]);

    const handleBack = () => {
      navigate(`/PeerReviewerEvaluationApproval/${id}`);
    };

    const handlePeerReviewerChange = useCallback((selected) => {
      setPeerReviewer(selected);
      setFormErrors((prev) => (prev.peerReviewer ? { ...prev, peerReviewer: "" } : prev));
    }, []);

    const handleApproverChange = useCallback((selected) => {
      setApprover(selected);
      setFormErrors((prev) => (prev.approver ? { ...prev, approver: "" } : prev));
    }, []);


    const handleFinalCostAllocation = useCallback(() => {
      if (!validateForm()) return;
      const applicationId = decryptAESID(id?.toString(), false);


      const req = {
        sGBPSApplicationId: applicationId,
        finalCostAllocationRequestListRequest: costAllocationList.map((row) => {
          const [certificateNumber, certPrefix] = row.label.split("/");

          return {
            sGBPSApplicationId: decryptAESID(id, false) ?? 0,
            itemCode: row.value?.value,
            tickRating: row.tickValue?.value,
            certificateNumber: certificateNumber + (certPrefix ? `/${certPrefix}` : ""),
            finalCertificateAndCostAllocationId: row?.finalCertificateAndCostAllocationId ?? 0,
            tvocEmission: row?.tvocEmission ?? "",
            formaldehydeEmission: row?.formaldehydeEmission ?? ""
          };
        })
      };
      sendFinalCertificateAndCostAllocation(req);
    }, [validateForm, id, internalNotes, peerReviewer, approver, costAllocationList, productList]);

    const peerReviewerOptions = useMemo(
      () => approverOptions.filter((opt) => opt.value !== approver?.value),
      [approverOptions, approver]
    );

    const approverSelectOptions = useMemo(
      () => approverOptions.filter((opt) => opt.value !== peerReviewer?.value),
      [approverOptions, peerReviewer]
    );

    const handleSendToFinalApprover = () => {
      let req = {
        sGBPProductInformationId: decryptAESID(id),
        PeerReviewerComment: peerReviewerComment
      }
      if (req) {
        sendToFinalApprover(req)
      }
    };

    const handlePeerReviewerCommentChange = (e) => {
      setPeerReviewerComment(e.target.value);
    };


    const handleReturn = () => {
      confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
        if (confirmed) {
          handleReturnApplication();
        }
      });
    };

    const handleReturnApplication = () => {
      let req = {}
      req.sGBPProductInformationId = decryptAESID(id);
      req.peerReviewerComment = peerReviewerComment
      req.FinalApproverComment = approverReviewerComment
      if (req) {
        // handleSave();
        returnToCaseOfficer(req)
        updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
      }
    };


    // Options for Dropdow
    return (
      <div className="certificate-grouping-list-page">
        <div className="crud-requirement-list">
          <div className="corporate-member-list">

            {/* Model Grouping Section */}
            <div className="table-title mt-2">
              <h3>Model Grouping</h3>
            </div>
            <div className="member-list">
              <div className="content-section">
                <div className="table-section">
                  <ModalGroupingTable
                    data={productList}
                    onChange={handleProductChange}
                    onApplicationNumberBlur={handleApplicationNumberBlur}
                    isDisabled={isApprove || true}
                  />
                </div>
              </div>
            </div>

            {/* Certificate and Cost Allocation Section */}
            <div className="table-title mt-4">
              <h3>Certificate and Cost Allocation</h3>
            </div>
            <CostAllocation
              rows={costAllocationList}
              onChange={handleCostAllocationChange}
              onTickChange={handleTickRatingChange}
              handleTVOCAndFormaldehydeChange={handleTVOCAndFormaldehydeChange}
              errors={formErrors.costAllocation}
              isDisabled={isApprove || true}
            />

            {/* Internal Notes Section */}
            <div className="table-title mt-5 mb-4">
              <h3>Internal Notes</h3>
            </div>
            <div className="mt-2">
              <label className="form-label">Comments from Case Officer</label>
              <textarea
                className="form-control mt-1"
                rows="4"
                value={internalNotes}
                onChange={(e) => setInternalNotes(e.target.value)}
                disabled
              ></textarea>
            </div>
            <div className="mt-2">
              <label className="form-label">Peer Reviewer Comment</label>
              <textarea
                className="form-control mt-1"
                rows="4"
                value={peerReviewerComment}
                onChange={handlePeerReviewerCommentChange}
                maxLength={200}
              ></textarea>
            </div>
            <div className="mt-2">
              <label className="form-label">Approver Reviewer Comment</label>
              <textarea
                className="form-control mt-1"
                rows="4"
                disabled
                value={approverReviewerComment}
              ></textarea>
            </div>

            {/* Assign to Section */}
            <div className="table-title mt-5 mb-4">
              <h3>Assign to</h3>
            </div>
            <div className="dropdown-select-wrapper">
              <div className="d-flex align-items-center mb-4">
                <label className="form-label mb-0 w-20">Peer Reviewer <span className="text-danger">*</span> </label>
                <div style={{ flex: 1 }}>
                  <Select
                    className="custom-checkbox-select"
                    value={peerReviewer}
                    options={peerReviewerOptions}
                    onChange={handlePeerReviewerChange}
                    placeholder="Select Peer Reviewer"
                    styles={errorSelectStyles}
                    hasError={Boolean(formErrors.peerReviewer)}
                    isDisabled
                  />
                  {formErrors.peerReviewer && (
                    <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                      {formErrors.peerReviewer}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex align-items-center">
                <label className="form-label mb-0 w-20">Approver <span className="text-danger">*</span></label>
                <div style={{ flex: 1 }}>
                  <Select
                    className="custom-checkbox-select"
                    value={approver}
                    options={approverSelectOptions}
                    onChange={handleApproverChange}
                    placeholder="Select Approver"
                    styles={errorSelectStyles}
                    hasError={Boolean(formErrors.approver)}
                    isDisabled
                  />
                  {formErrors.approver && (
                    <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                      {formErrors.approver}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex justify-content-between mt-5">
              <Buttons
                buttonText="Back"
                buttonTypeClassName="black-btn"
                onClick={handleBack}
              />
              <div className="d-flex gap-3">
                <Buttons
                  buttonText="Return"
                  buttonTypeClassName="reject btn"
                  onClick={handleReturn}
                  isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
                  isDisable={returnToCaseOfficeLoading || updateStatusOnReturnLoading}
                />
                <Buttons
                  buttonText="Recommend for Certification"
                  buttonTypeClassName="success-btn"
                  onClick={handleSendToFinalApprover}
                  isLoading={sendCertificateGroupingForReviewLoading}
                  isDisable={sendCertificateGroupingForReviewLoading}
                />

              </div>
            </div>

          </div>
        </div>
      </div>
    );
  };

export default CertificateGroupingListTVOCReview
  ;
